import * as React from "react";

import { Address } from "src/library/components/Address";
import { Datetime } from "src/library/components/Datetime";
import { InfoBar } from "src/library/components/InfoBar";
import { PhoneNumber } from "src/library/components/PhoneNumber";
import type { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import CustomerStatus from "src/core/customers/components/CustomerDropStatus";
import CustomerActiveDropsCount from "src/core/customers/components/CustomerActiveDropsCount";
import type { ICustomer } from "src/core/customers/api/customers.api";

interface IProps {
  isLoading: boolean;
  data: ICustomer | null;
  primaryAction?: JSX.Element | null;
  secondaryAction?: JSX.Element | null;
  terminology: ITerminology;
}

const CustomerInfoSidebar = ({
  isLoading, data, primaryAction, secondaryAction, terminology
}: IProps) => {
  return (
    <InfoBar
      isLoading={isLoading}
      title={`${terminology.customer.singular.text} information`}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      items={[
        {
          label: "Account status",
          value: data ? <CustomerStatus status={data.status} /> : "-"
        },
        {
          label: "Account",
          value: data ? data.name : "-"
        },
        {
          label: `${terminology.cutOff.singular.text} time for ${terminology.order.singular.text}ing`,
          value: "-"
        },
        {
          label: `Active ${terminology.user.singular.text}`,
          value: "-"
        },
        {
          label: `Active ${terminology.drop.singular.text}`,
          value: data ? <CustomerActiveDropsCount drops={data.branches} /> : "-"
        },
        {
          label: "Address",
          value: data ? <Address address={data.address} /> : "-"
        },
        {
          label: "Created On",
          value: data ? (
            <Datetime
              date={data.createdAt}
              template="long_date"
            />
          ) : "-"
        },
        {
          label: "Contact name",
          value: data ? data.contactName : "-"
        },
        {
          label: "Contact number",
          value: data ? (
            <PhoneNumber
              phoneNumber={data.contactNumber}
              linked
            />
          ) : "-"
        },
        {
          label: "Contact email",
          value: data ? (
            <a href={`mailto: ${data.contactEmail}`}>
              {data.contactEmail}
            </a>
          ) : "-"
        }
      ]}
    />
  );
};

export default CustomerInfoSidebar;
